/** 路由栈分组配置 */
export const ROUTE_STACK_GROUPS = {
  venueManage: {
    /** 模块未登录时跳转的登录页路由名 */
    login: 'venueManageLogin',
    /** 模块对应的 vuex 命名空间 */
    authModule: 'venueManage',
    /** 回主页目标路由名 */
    home: 'venueManage',
    /** 参与栈的路由名（顺序即层级） */
    routes: [
      'venueManageLogin',
      'venueManage',
      'venueAttendanceDetail',
      'attendanceCheckIn'
    ],
    /** 栈仅一页时，返回按钮 fallback 父路由；null 表示离开模块 */
    parent: {
      venueManageLogin: null,
      venueManage: null,
      venueAttendanceDetail: 'venueManage',
      attendanceCheckIn: 'venueAttendanceDetail'
    },
    /** 离开模块时的 fallback 路径 */
    externalFallback: '/'
  }
}

/** 根据路由名获取分组 key */
export const getGroupKeyByRouteName = name => {
  if (!name) return ''
  return Object.keys(ROUTE_STACK_GROUPS).find(key =>
    ROUTE_STACK_GROUPS[key].routes.includes(name)
  )
}
